export default "__VITE_ASSET__3D5KkfLk__"